// extracted by mini-css-extract-plugin
export var aboveInput = "_nr-0";
export var actionButton = "_nr-5";
export var actionButtonContainer = "_nr-1";
export var actionIcon = "_nr-6";
export var aiInfoContainer = "_nr-2";
export var attachmentWrapper = "_nr-7";
export var bold = "_nr-3";
export var checkIcon = "_nr-8";
export var clickingRecipientBar = "_nr-11";
export var commentThreadSwitch = "_nr-a";
export var draftImage = "_nr-b";
export var draftImageContainer = "_nr-c";
export var draftImages = "_nr-e";
export var editButton = "_nr-g";
export var editor = "_nr-f";
export var editorContainer = "_nr-y";
export var editorErrorTooltipWrapper = "_nr-9";
export var headerDivider = "_nr-h";
export var icon = "_nr-i";
export var info = "_nr-j";
export var internal = "_nr-n";
export var internalDivider = "_nr-k";
export var internalMessage = "_nr-l";
export var messageInputCard = "_nr-m";
export var messageInputForm = "_nr-o";
export var messageInputFormInternal = "_nr-p";
export var options = "_nr-q";
export var publicMessageCustomer = "_nr-s";
export var publicMessageMerchant = "_nr-r";
export var removeImageButton = "_nr-d";
export var replyButtons = "_nr-t";
export var showSignatureButton = "_nr-u";
export var spinner = "_nr-v";
export var verticalButtonDivider = "_nr-4";
export var visibilitySelector = "_nr-w";
export var warning = "_nr-x";
export var wrappingText = "_nr-z";
export var writingInternalNoteTopBorder = "_nr-10";